// extracted by mini-css-extract-plugin
export default {"commentIcon":"CommentCellRenderer_commentIcon__6f8-m"};